module.exports = __webpack_public_path__ + "static/img/BOSTON_OAK.1335346.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/BOSTON_OAK.jpg
// module id = W4BH
// module chunks = 0